import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type TSaveCoReqCourseToTermAP1Command = (
  courseId: number,
  termId: number,
  slotId: number
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory('saveCoReqCourseToTermAP1Command', ($http: ng.IHttpService, defineCommandORM: IDefineCommand): ICommand => {
    return defineCommandORM(
      'saveCoReqCourseToTermAP1Command',
      (deferred, courseId: number, termId: number, slotId: number) => {
        /* tslint:disable:no-null-keyword*/
        const calcSlotId = _4.isUndefined(slotId) || _4.isNull(slotId) || slotId < 1 ? null : slotId;
        const payload = {
          course_id: courseId,
          term_id: termId,
          slot_id: calcSlotId
        };

        return $http
          .post(`/reg/academicplan/`, payload)
          .catch(deferred.reject)
          .then(() => deferred.resolve());
      }
    );
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/commands/save_coreq_course_to_term_ap1_command.ts